import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, map } from 'rxjs'
import { PaginatedList } from 'src/app/shared/interfaces/api-response/api-paginated-list.interface'
import { ApiResponsePaginatedList } from 'src/app/shared/interfaces/api-response/api-paginated-response.interface'
import { SmartQuoteBespokeFavouriteFilter } from 'src/app/shared/interfaces/smartquote-bespoke-favourite/smartquote-bespoke-favourite-filter.interface'
import { SmartQuoteBespokeFavourite } from 'src/app/shared/interfaces/smartquote-bespoke-favourite/smartquote-bespoke-favourite.interface'
import { environment } from 'src/environments/environment'
import { getPagedFilterParams } from '../../helpers/get-filters'

@Injectable({
    providedIn: 'root',
})
export class SmartquoteBespokeFavouriteService {
    constructor(private httpClient: HttpClient) {}

    getBespokeFavourites(
        filter: SmartQuoteBespokeFavouriteFilter
    ): Observable<PaginatedList<SmartQuoteBespokeFavourite>> {
        const params = getPagedFilterParams(filter)

        return this.httpClient
            .get<ApiResponsePaginatedList<SmartQuoteBespokeFavourite>>(
                `${environment.baseUrl}SmartQuote/BespokeFavourite`,
                { params }
            )
            .pipe(map((x) => x.result))
    }

    createBespokeFavourite(favourite: SmartQuoteBespokeFavourite): Observable<SmartQuoteBespokeFavourite> {
        return this.httpClient.post<SmartQuoteBespokeFavourite>(
            `${environment.baseUrl}SmartQuote/BespokeFavourite`,
            favourite
        )
    }

    updateBespokeFavourite(favourite: SmartQuoteBespokeFavourite): Observable<SmartQuoteBespokeFavourite> {
        return this.httpClient.put<SmartQuoteBespokeFavourite>(
            `${environment.baseUrl}SmartQuote/BespokeFavourite/${favourite.id}`,
            favourite
        )
    }

    deleteBespokeFavourite(id: number): Observable<void> {
        return this.httpClient.delete<void>(`${environment.baseUrl}SmartQuote/BespokeFavourite/${id}`)
    }
}
